import { render, staticRenderFns } from "./ProfileVitalSignBodyMassDetail.vue?vue&type=template&id=03519fda&"
import script from "./ProfileVitalSignBodyMassDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileVitalSignBodyMassDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports